import { render } from "./Loading.vue?vue&type=template&id=7dc60122&scoped=true"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=7dc60122&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc60122"]])

export default __exports__